import * as React from "react";
import styled, { css } from "react-emotion";
import { spacing, breakpoints } from "../theme/layout";
import { primaryColors } from "../theme/colors";
import { H3 } from "../theme/text";
import { Icon } from "../theme/icons/index";
import { paragraph } from "../theme/typefaces";
/** Style for Modal Overlay */
export const modalOverlayStyle = css `
  background: rgba(80, 130, 179, 0.7); // Zürich Blue with opacity 0.7
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 12;
`;
/** Style for React modal  */
export const reactModalStyle = css `
  position: relative;
  top: 5vh;
  left: 0;
  right: 0;
  bottom: 0;
  border: none;
  background: none;
  border-radius: 0px;
  outline: none;
  max-width: 630px;
  margin: 0 auto;
  z-index: 13;
  ${spacing.pa2};
`;
/** Overall stlye for  */
const modalStyle = css `
  max-width: 630px;
  height: 85vh;
  margin: 0 auto;
  overflow: auto;
  background-color: ${primaryColors.white};
  ${spacing.pa3};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  & h4 {
    ${spacing.mt0};
    ${spacing.mh0};
    ${spacing.mb3};
    ${spacing.pa0};
  }

  & p {
    ${spacing.mt0};
    ${spacing.mh0};
    ${spacing.mb2};
    ${spacing.pa0};
  }

  ${breakpoints.medium `
    height: 630px;
  `};
`;
/** Style for Modal Children */
export const ModalText = styled("div") `
  ${paragraph};
  ${spacing.mt1};
  max-width: 100%;
  display: block;
  overflow: auto;
`;
const modalCloseIconStyle = css `
  cursor: pointer;
  align-self: flex-end;
  font-size: 2em;
  background: transparent;
  color: ${primaryColors.zuerichBlue};
`;
export const Modal = ({ mainHeading, iconName, onClose, children }) => (<div className={modalStyle}>
    <button className={css `
        all: unset;
        border: none;
        text-decoration: none;
        ${modalCloseIconStyle};
      `} onClick={onClose}>
      <Icon name={"Cross"}/>
    </button>
    <div>
      <H3>{mainHeading}</H3>
      {children}
    </div>
  </div>);



// WEBPACK FOOTER //
// ./src/components/Modals.tsx